import React from 'react';
import { useSelector } from 'react-redux';
import { Menu, Dropdown } from 'antd';
import { SubnodeOutlined } from '@ant-design/icons';

import { RibbonButton } from 'common/components';
import gridViewSelectors from 'common/components/grid-view/controllers/selectors';
import CreateMasterAplRibbon from 'pages/home/ribbon/components/sections/product-apl/CreateMasterAplRibbon';
import RollbackToPreviousMasterAplRibbon from 'pages/home/ribbon/components/sections/product-apl/RollbackToPreviousMasterAplRibbon';
import CreateApl from 'pages/home/ribbon/components/controls/product-apl/CreateApl';
import EditAPLRibbon from 'pages/home/ribbon/components/sections/product-apl/EditAPLRibbon';
import DeleteAplControl from 'pages/home/ribbon/components/controls/product-apl/DeleteAplControl';
import DownloadAplTemplate from 'pages/home/ribbon/components/controls/product-apl/DownloadAplTemplate';
import CreateEditAplModal from './components/CreateEditAplModal';
import UpdateMasterAPLRibbon from './UpdateMasterAPLRibbon';

import { useGlobalModal } from 'hooks';

import messages from 'i18n/messages/home';

const AplGridActions = () => {
  const selectedAPLs = useSelector(
    gridViewSelectors.makeSelectDetailCurrentITemsSelection()
  );

  const { checkModalVisible, MODAL_NAMES } = useGlobalModal();

  const isModalOpen =
    checkModalVisible(MODAL_NAMES.CREATE_MASTER_APL) ||
    checkModalVisible(MODAL_NAMES.EDIT_APL) ||
    checkModalVisible(MODAL_NAMES.CREATE_APL);
  const menuOptions = (
    <Menu>
      <Menu.Item key='create-master-apl'>
        <CreateMasterAplRibbon />
      </Menu.Item>

      <Menu.Item key='update-master-apl'>
        <UpdateMasterAPLRibbon />
      </Menu.Item>

      <Menu.Item key='roll-back-master-apl'>
        <RollbackToPreviousMasterAplRibbon />
      </Menu.Item>

      <Menu.Item key='create-apl' style={{ backgroundColor: 'inherit' }}>
        <CreateApl />
      </Menu.Item>

      <Menu.Item key='edit-apl'>
        <EditAPLRibbon />
      </Menu.Item>

      <Menu.Item
        key='delete-product-apl-grid'
        style={{ backgroundColor: 'inherit' }}
      >
        <DeleteAplControl selectedItems={selectedAPLs} />
      </Menu.Item>

      <Menu.Item key='pim-add-product' style={{ backgroundColor: 'inherit' }}>
        <DownloadAplTemplate />
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
        <RibbonButton icon={<SubnodeOutlined />} label={messages.aplActions} />
      </Dropdown>
      {isModalOpen && <CreateEditAplModal />}
    </>
  );
};

export default AplGridActions;
